export const categories = state => state.categories;

export const activeArticle = state => state.activeArticle;

export const theme = state => state.theme;

export const currency = state => state.currency;

export const weather = state => state.weather;

export const football = state => state.football;

export const population = state => state.population;

export const populationPretty = state => state.population.toLocaleString().replace(/,/g, " ",)

export const populationNum = state => parseInt(state.population.toLocaleString().replace(/,/g, "",))

export const movies = state => state.movies;

// Registration
export const userModel = state => state.userModel

// Main
export const latestNews = state => state.latestNews;

export const currentPage = state => state.currentPage;

export const newsCount = state => state.newsCount;

export const uzbekistanNews = state => state.uzbekistanNews;

// Search
export const searchNews = state => state.searchNews;

export const searchPage = state => state.searchPage;

export const searchCount = state => state.searchCount;

export const searchReccomend = state => state.searchReccomend;

// Staff Team
export const employees = state => state.employees;

export const employeesPage = state => state.employeesPage;

export const employeesCount = state => state.employeesCount;

export const journalists = state => state.journalists;

export const journalistsPage = state => state.journalistsPage;

export const journalistsCount = state => state.journalistsCount;

export const searchReccomendPage = state => state.searchReccomendPage;

export const searchReccomendCount = state => state.searchReccomendCount;

// Auth
export const access = state => state.access

export const refresh = state => state.refresh

// Staff
export const user = state => state.user

export const newArticle = state => state.newArticle

export const subCategories = state => state.subCategories

export const tags = state => state.tags

// Staff News
export const staffNews = state => state.staffNews

export const staffPage = state => state.staffPage

export const staffCount = state => state.staffCount

// admin News
export const adminNews = state => state.adminNews

export const adminPage = state => state.adminPage

export const adminCount = state => state.adminCount

export const authorsList = state => state.authorsList

// export const currentMessages = state => {
//   const thread = currentThread(state)
//   return thread.messages
//     ? thread.messages.map(id => state.messages[id])
//     : []
// }

// export const unreadCount = ({ threads }) => {
//   return Object.keys(threads).reduce((count, id) => {
//     return threads[id].lastMessage.isRead ? count : count + 1
//   }, 0)
// }

// export const sortedMessages = (state, getters) => {
//   const messages = getters.currentMessages
//   return messages.slice().sort((a, b) => a.timestamp - b.timestamp)
// }
